const postContent = document.querySelector(".portfolio-single-content");
const getAllH2 = postContent.querySelectorAll("h2");
let contentHeadingCounter = 0;

const summaryList = document.querySelector(".summary-list");

getAllH2.forEach((header) => {
  contentHeadingCounter++;
  header.setAttribute("id", `header-${contentHeadingCounter}`);
  header.classList.add("anchor-hash-content");

  const summaryItem = document.createElement("li");
  summaryItem.classList.add("summary-item");
  summaryItem.innerHTML = `<a href="header-${contentHeadingCounter}" class="anchor-hash-header">${header.innerText}</a>`;
  summaryItem.setAttribute("data-state", "");

  summaryItem.addEventListener("click", () => summaryClick(summaryItem));
  summaryItem.addEventListener("click", (evt) => handleClick(evt));

  summaryList.appendChild(summaryItem);
});

function summaryClick(summaryItem) {
  summaryList.querySelectorAll("li").forEach((item) => {
    item.setAttribute("data-state", "");
  });
  if (summaryItem.getAttribute("data-state") === "") {
    summaryItem.setAttribute("data-state", "active");
    return;
  }
}

function handleClick(event) {
  event.preventDefault();
  const headerOffset = document.querySelector(".header").clientHeight + 20; // полная высота header'a
  const contentAnchors = document.querySelectorAll(".anchor-hash-content");
  const href = event.target.getAttribute("href");
  const elementToScroll = Array.from(contentAnchors).filter(
    (item) => item.getAttribute("id") === href
  );

  const elementPosition = elementToScroll[0].offsetTop;
  window.scrollTo({
    top: elementPosition - headerOffset,
    behavior: "smooth",
  });
}
